export const getContactStateColor = (status?: string | null): SlugColorType => {
  if (!status) return 'gray';

  switch (status) {
    case 'active':
      return 'main';
    case 'goal_reached':
      return 'success';
    default:
      return 'danger';
  }
};
